class SlideNav extends HTMLElement{
  constructor(){
    super()
    this.container = this.getAttribute('data-id');
    this.Maincontainer = document.getElementById(this.container)
  }
  connectedCallback(){
    this.init()
  }
  init(){
      this.addEventListener('click',this.slideToslide.bind(this))
  }
  slideToslide(event){
    let hasPrev = this.hasAttribute('data-prev');
    if(!this.Maincontainer) return;
    if(hasPrev){
      this.Maincontainer.querySelector('.flickity-previous').click()  
    }
    else{
      this.Maincontainer.querySelector('.flickity-next').click()  
    }
  }
}

customElements.define("slide-nav", SlideNav);

// document.addEventListener("DOMContentLoaded", (event) => {
//   const allGridSubmit = document.querySelectorAll('.grid-product__content .product-single__form .add-to-cart');
//   if(allGridSubmit){
//     allGridSubmit.forEach(function(submitButton){
//       submitButton.addEventListener('click',function(e){
//         e.preventDefault();
//         this.classList.add('btn--loading')
//         let form = this.closest('.product-single__form')
//         const formData = new FormData(form);
//         fetch(window.Shopify.routes.root + 'cart/add.js', {
//           method: 'POST',
//           body: formData
//         })
//         .then(response => {
//            return response.json();
//         })
//         .then((data)=>{
//           this.classList.remove('btn--loading');
//           document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
//             detail: {
//               product: data,
//               addToCartBtn: submitButton
//             },
//             bubbles: true
//           }));
//           document.dispatchEvent(new Event('cart:build'))
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         });
        
//       })
//     });
//   }
//     const allFeatureSubmit = document.querySelectorAll('.sales-featured-product .product-single__form .add-to-cart');
//   if(allFeatureSubmit){
//     allFeatureSubmit.forEach(function(submitButton){
//       submitButton.addEventListener('click',function(e){
//         e.preventDefault();
//         let form = this.closest('.product-single__form')
//         const formData = new FormData(form);
//         fetch(window.Shopify.routes.root + 'cart/add.js', {
//           method: 'POST',
//           body: formData
//         })
//         .then(response => {
//            return response.json();
//         })
//         .then((data)=>{
//           document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
//             detail: {
//               product: data,
//               addToCartBtn: submitButton
//             },
//             bubbles: true
//           }));
//           document.body.style.overflow ="inherit"
//           document.dispatchEvent(new Event('cart:build'))
//         })
//         .catch((error) => {
//           console.error('Error:', error);
//         });
//       });
//     });
//   }
  
// });

class Addtocartbtn extends HTMLElement {
  constructor() {
    super()
    this.button = this
    this.button.addEventListener('click',this.fnAddtocart.bind(this))
  }
  fnAddtocart(event){
    let varaintId = parseInt(this.getAttribute('data-variant-id'));
    this.button.classList.add('btn--loading')
    let quantity = this.getAttribute('data-quantity')? parseInt(this.getAttribute('data-quantity')) :1;
    let formData = {
      id:varaintId,
      quantity:quantity
    }
      fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          // document.dispatchEvent(new Event('ajaxProduct:added'))
          //if(window.SLIDECART){
            document.dispatchEvent(new Event('ajaxProduct:added'));
            //window.SLIDECART_UPDATE();
            //window.SLIDECART_OPEN();
            this.button.classList.remove('btn--loading');
         // }
          return response.json();
        })
        .catch((error) => {
          this.button.classList.remove('btn--loading');
          console.error('Error:', error);
        });
  }
}
customElements.define("add-to-cart", Addtocartbtn);